<script lang="tsx">
  import { Skeleton } from "primevue";
  import Image from "./Image.vue";

  export default {
    components: { Skeleton, Image },
    props: Image.props as (typeof Image["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <Image v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <Skeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>
